import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { compose, withHandlers, withState } from 'recompose';
import { withEscHandler } from 'shared/hocs/modalWithEscHandler';
import { removeModal } from 'modules/messageSystem/actions/removeModal';
import { getConversationParticipant } from 'modules/appointmentInfo/selectors/currentAppointment';

import ModalStartConsultation from './ModalStartConsultation';


const mapStateToProps = (state, ownProps) => ({
  clinician: getConversationParticipant(state),
  callerName: state.conference.currentConversation.call.callerName,
  isDialer: ownProps.bodyValues.isDialer,
  healthcareName: ownProps.bodyValues.healthcareName,
  callDeadLineTimestamp: state.conference.currentConversation.call.callDeadLineTimestamp,
});

export default compose(
  connect(mapStateToProps, { removeModal }),

  withState('isAcceptCallDisabled', 'disableAcceptButton', false),

  withHandlers({
    disableAcceptButton: ({ disableAcceptButton }) => () => {
      return disableAcceptButton(true);
    },

  }),

  withEscHandler,
  injectIntl,
)(ModalStartConsultation);
